<template>
  <div>
    <component :is="comp" :content="content" :class="className" />
  </div>
</template>

<script>
// import Resources from './Resources.vue';
import Columns1 from './Columns1.vue';
import Columns2 from './Columns2.vue';

export default {
  props: {
    content: {
      default: {
        item: {},
        section: '',
      }
    }
  },

  watch:{
    'content.item'(){
      this.defineComponent();
    }
  },

  data() {
    return {
      comp: null,
      className: [],
    }
  },

  methods: {
    defineComponent(){
      let columns = 1;
      if(this.content.item.content_column_2){
        columns = 2;
      }

      if(this.content.item.ball_label == 'Recursos'){
        this.className = ['resources-list'];
      } else {
        this.className = null;
      }
      
      if(columns == 2) {
        this.comp = Columns2;
      } else {
        this.comp = Columns1;
      }
    }
  },

  created(){
    this.defineComponent();
  }
}
</script>